// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const License = {
  Pioneer: "pioneer",
  Hcc: "hcc",
  Lizard: "lizard",
} as const;
export type License = (typeof License)[keyof typeof License];

export function instanceOfLicense(value: any): boolean {
  for (const key in License) {
    if (Object.prototype.hasOwnProperty.call(License, key)) {
      if (License[key as keyof typeof License] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LicenseFromJSON(json: any): License {
  return LicenseFromJSONTyped(json, false);
}

export function LicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): License {
  return json as License;
}

export function LicenseToJSON(value?: License | null): any {
  return value as any;
}

export function LicenseToJSONTyped(value: any, ignoreDiscriminator: boolean): License {
  return value as License;
}
